import React from 'react';


const Button = ({ backgroundColor, disabled, onClick, children}) => {



  return <div   className="flex justify-center">
  <div style={{ backgroundColor: backgroundColor }} className={(backgroundColor ? "" : "bg-primary text-white  ") + "button rounded-lg flex button-effect justify-between whitespace-nowrap items-center  gap-2  lg:px-5 lg:py-3 px-2 py-1  ease-in-out duration-300 transition-all bg-tertiary text-white   uppercase " + (disabled ? "pointer-events-none opacity-20" : "cursor-pointer hover:border-black")} onClick={onClick}><div className="relative">{children}</div></div>
</div>
}

export default Button;
